<ng-container *ngIf="alert">
    <a
        *ngIf="alert.actionPrimaryLink"
        nz-button
        nzType="primary"
        [href]="alert.actionPrimaryLink"
        [target]="isExternalLink(alert.actionPrimaryLink) ? '_blank' : ''"
    >
        {{ alert.actionPrimaryText }}
    </a>

    <a
        *ngIf="alert.actionSecondaryLink"
        nz-button
        nzType="default"
        [href]="alert.actionSecondaryLink"
        [target]="isExternalLink(alert.actionPrimaryLink) ? '_blank' : ''"
    >
        {{ alert.actionSecondaryText }}
    </a>
</ng-container>
